/**
 * Meant to manage configurations between environment types (e.g. Prod, Dev).
 */
import { commonConfiguration as appCoreCommonConfiguration } from '../application/reduxAppCore'
const config = {
  dev: [],
  prod: [],
  common: appCoreCommonConfiguration,
}

function buildConfiguration(env) {
  return env !== 'production'
    ? [...config.common, ...config.dev]
    : [...config.common, ...config.prod]
}

export function getStoreConfig() {
  return buildConfiguration(process.env.NODE_ENV)
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/config/appStoreConfig.js